"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOptionDropdown = void 0;
const react_1 = __importDefault(require("react"));
const useKeyboardEvents_1 = require("./useKeyboardEvents");
function useOptionDropdown(props) {
    const { isSelect, dropdownOptions = [], onSelectOption = () => { }, onEnter, isFocused } = props;
    const inputRef = react_1.default.useRef(null);
    // Id for aria-controls
    const dropdownId = react_1.default.useId();
    const blurInput = react_1.default.useCallback(() => {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
    }, []);
    const onSelectCallback = react_1.default.useCallback((option) => {
        onSelectOption(option);
        blurInput();
    }, [onSelectOption, blurInput]);
    const { focusedOptionIdx, handleKeyDown, iconButtonRef, handleCompositionStart, handleCompositionEnd } = (0, useKeyboardEvents_1.useKeyboardEvents)({
        dropdownOptions,
        onEnter,
        onSelectCallback,
        blurInput
    });
    const showDropdown = isSelect && isFocused;
    const handleClickOption = react_1.default.useCallback((event) => {
        const { relatedTarget } = event;
        if (relatedTarget && relatedTarget instanceof HTMLElement) {
            if (relatedTarget.getAttribute("role") === "option") {
                const { elementIdx } = relatedTarget.dataset;
                const selectedOption = dropdownOptions[Number(elementIdx)];
                onSelectCallback(selectedOption);
            }
        }
    }, [dropdownOptions, onSelectCallback]);
    const ariaPropsForDropdown = {
        "aria-expanded": isSelect ? showDropdown : undefined,
        "aria-haspopup": isSelect ? "listbox" : false,
        "aria-controls": isSelect ? dropdownId : undefined,
        role: isSelect ? "combobox" : undefined
    };
    return {
        ariaPropsForDropdown,
        focusedOptionIdx,
        handleClickOption,
        handleKeyDown,
        iconButtonRef,
        inputRef,
        showDropdown,
        handleCompositionStart,
        handleCompositionEnd
    };
}
exports.useOptionDropdown = useOptionDropdown;
//# sourceMappingURL=useOptionDropdown.js.map